<template>
  <div class="drawer-mobile-wrapper">
      <!--tab menu-->
    <div class="drawer-mobile__tabs-menu">
      <!--<div class="drawer-mobile__left-action">-->
        <button :class="currentTab === 1 ? 'active' : ''" class="tabs-menu__item tabs-menu__item--edit" @click="currentTab = 1">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg>
        </button>
      <!--</div>-->
      <!--<div class="drawer-mobile__center-nav">-->
        <!--<button class="tabs-menu__item">Editor</button>-->
        <button class="tabs-menu__item has-badge tabs-menu__item--save-outfit" @click="currentTab = 2">
          <!--<span :class="snapshots.length > 0 ? 'bg-red text-white' : 'bg-gray text-black'" class="badge">{{ snapshots.length }}</span>-->
          Outfit: {{ snapshots.length }}
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path></svg>

        </button>
      <!--</div>-->
      <!--<div class="drawer-mobile__right-action">-->

        <!--<button class="tabs-menu__item tabs-menu__item&#45;&#45;save">-->
          <!--<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>-->
        <!--</button>-->
        <save-button></save-button>
      <!--</div>-->

    </div>

    <div class="drawer-mobile__tabs">
      <transition name="slide-up">
        <tab title="Edit Outfit" v-if="currentTab === 1" @dismiss="currentTab = null">
          <div class="tabs-item__content pt-4">

            <tab-configuration></tab-configuration>

          </div>
        </tab>
      </transition>

      <transition name="slide-up">
        <tab title="Outfit list" v-if="currentTab === 2" @dismiss="currentTab = null">
          <div class="tabs-item__content">

            <outfits-carousel></outfits-carousel>

          </div>
        </tab>
      </transition>
      <!--<transition name="slide-up">-->
        <!--&lt;!&ndash;todo make a component&ndash;&gt;-->
        <!--<div class="drawer-mobile__tabs-item" v-if="currentTab === 1">-->
          <!--<div class="flex justify-between tabs-item__header">-->
            <!--<h4 class="text-button font-bold">-->
              <!--Edit Outfit-->
            <!--</h4>-->
            <!--<button class="tab-item__button-dismiss" @click="currentTab = null">-->
              <!--<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>-->
            <!--</button>-->
          <!--</div>-->
          <!--<div class="tabs-item__content">-->

          <!--</div>-->
          <!--<div class="tabs-item__footer">-->

          <!--</div>-->

        <!--</div>-->
      <!--</transition>-->

      <!--<transition name="slide-up">-->
        <!--&lt;!&ndash;todo make a component&ndash;&gt;-->
        <!--<div class="drawer-mobile__tabs-item" v-if="currentTab === 2">-->
          <!--<div class="flex justify-between">-->
            <!--<h4 class="text-button font-bold">-->
              <!--Sanpshots-->
            <!--</h4>-->
            <!--<button class="tab-item__button-dismiss" @click="currentTab = null">-->
              <!--<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>-->
            <!--</button>-->
          <!--</div>-->
        <!--</div>-->
      <!--</transition>-->


    </div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SaveButton from './partials/SaveButton'
  import Tab from './tabs/MobileTab'
  import TabConfiguration from './tabs/TabConfiguration'
  import OutfitsCarousel from './partials/OutfitsCarousel'

  export default {
    name: "DrawerMobile",
    components: {
      SaveButton,
      Tab,
      TabConfiguration,
      OutfitsCarousel,
    },
    data() {
      return {
        currentTab: null,
      }
    },
    computed: {
      ...mapGetters('snapshots',[
        'snapshots'
      ]),
    }
  }
</script>

<style scoped>
  .drawer-mobile-wrapper {
    width: 100vw;
    min-height: 60px;
    background-color: white;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column-reverse;
  }

  .drawer-mobile__tabs-menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 15px 20px;
    z-index: 20;
    background-color: white;
    border-top: 1px solid #CDCDCD;
  }

  .drawer-mobile__right-action {
    width: max-content;
  }

  .drawer-mobile__tabs-menu .tabs-menu__item {
    padding: 5px;
  }

  .tabs-menu__item.tabs-menu__item--edit {
    color: #333;
    background-color: white;
    border: 1px solid #7C7C7C;
    padding: 0px;
    /*font-size: 14px;*/
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tabs-menu__item.active {
    color: red;
    border-color: red;
  }

  /*.tabs-menu__item.tabs-menu__item--save {*/
    /*color: white;*/
    /*background-color: red;*/
    /*border: 1px solid red;*/
    /*padding: 0px;*/
    /*!*font-size: 14px;*!*/
    /*width: 40px;*/
    /*height: 40px;*/
    /*border-radius: 50%;*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  /*}*/

  .tabs-menu__item.tabs-menu__item--save-outfit {
    /*padding-left: 30px;*/
  }

  .tabs-menu__item.tabs-menu__item--save-outfit svg {
    position: absolute;
    left: calc(50% - 12px);
    top: -10px;
  }

  .drawer-mobile__left-nav {
    text-align: center;
    width: 100%;
    padding-left: 40px;
  }

  .has-badge {
    position: relative;
  }

  .badge {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0px;
    top: calc(50% - 10px);
  }

  .drawer-mobile__tabs {
    position: relative;
    width: 100vw;
  }

  .drawer-mobile__tabs-item {
    transition: all 0.5s ease-in-out;
    z-index: 15;
    position: absolute;
    width: 100vw;
    /*min-height: 30vh;*/
    bottom: 0;
    background-color: #F4F4F4;
    padding: 20px;
  }

  .slide-up-enter-active, .slide-up-leave-active {
    opacity: 1;
    /*z-index: 15;*/
  }
  .slide-up-enter, .slide-up-leave-to {
    opacity: 0;
    transform: translateY(100%);
  }

  .slide-up-leave-to {
    z-index: 5;
  }

  .tab-item__button-dismiss {
    color: #7C7C7C;
  }

</style>